// extracted by mini-css-extract-plugin
export default {"container":"component_form_yandex_container__wc8vv","checkboxGroup":"component_form_yandex_checkboxGroup__8F5tI","singleCheckbox":"component_form_yandex_singleCheckbox__qPdqI"};